var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveLevel1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.612,
    height: 42.205,
    viewBox: "0 0 23.612 42.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2642",
    "data-name": "Group 2642",
    transform: "translate(-684.947 -41.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M311.547,46.8V20.2a2.328,2.328,0,0,0-1.164-2.017l-9.477-5.472a2.328,2.328,0,0,0-2.328,0L289.1,18.18a2.328,2.328,0,0,0-1.164,2.017V46.8a2.328,2.328,0,0,0,1.164,2.017l9.477,5.472a2.328,2.328,0,0,0,2.328,0l9.477-5.472a2.328,2.328,0,0,0,1.164-2.017",
    transform: "translate(397.012 29.443)",
    fill: "#99b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M313.811,50.509V26.1a2.328,2.328,0,0,0-1.164-2.017l-7.58-4.376a2.33,2.33,0,0,0-2.328,0l-7.579,4.376a2.329,2.329,0,0,0-1.164,2.017V50.509a2.329,2.329,0,0,0,1.164,2.017l7.579,4.376a2.328,2.328,0,0,0,2.328,0l7.58-4.376a2.329,2.329,0,0,0,1.164-2.017",
    transform: "translate(392.85 24.608)",
    fill: "#e0effd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M316.1,69.273l-2.684,1.41.513-2.989-2.172-2.116,3-.435,1.342-2.72,1.342,2.72,3,.435-2.171,2.116.513,2.989Z",
    transform: "translate(380.648 -3.423)",
    fill: "#99b1c7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLevel1);
export default __webpack_public_path__ + "static/media/activeLevel1.8aaf43e7a37390617d8513328dd9213c.svg";
export { ForwardRef as ReactComponent };